/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import './src/translation/i18n';

import React from 'react';

import { GatsbyBrowser } from 'gatsby';

import { LocationContext } from './src/contexts/LocationContext';
import PreviewConnectorProvider from './src/preview/PreviewConnectorProvider';
import { PreviewStateProvider } from './src/preview/PreviewStateContext';
import { GlobalStateProvider } from './src/state/globalStateContext';

import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(useGSAP, ScrollTrigger, SplitText, CustomEase);

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return (
    /* <I18nextProvider i18n={i18n}> */
    <GlobalStateProvider>
      <LocationContext.Provider value={props.location}>
        <PreviewStateProvider>
          <PreviewConnectorProvider>{element}</PreviewConnectorProvider>
        </PreviewStateProvider>
      </LocationContext.Provider>
    </GlobalStateProvider>
    /* </I18nextProvider> */
  );
};

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`);
  }
};
